import { createApiRef } from '@backstage/core-plugin-api';

type ReleaseCb = () => void;

/**
 * WbSafeNunjucksApi is an API to render Nunjucks templates without using unsafe-eval
 * Templates must be registered before rendering.
 */
export interface WbSafeNunjucksApi {
  /**
   * Loads nunjucks templates and makes them available for rendering.
   * Returns a release function to mark the templates as no longer needed and ready to be unloaded.
   */
  load: (templates: string[]) => ReleaseCb;
  /**
   * Render a previously loaded template with data.
   * If the template wasn't loaded previously or an error is thrown, returns undefined.
   */
  render: (
    template: string,
    context: Record<string, any>,
  ) => string | undefined;
}

/**
 * The API reference for the WbSafeNunjucksApi.
 * @public
 */
export const wbSafeNunjucksApiRef = createApiRef<WbSafeNunjucksApi>({
  id: 'plugin.wb-safe-nunjucks',
});
